/* eslint-disable import/no-anonymous-default-export */
import HomePage from "./homepage";

export default { HomePage };
